import http from "@/http/aisea/axios";

const resource = "/voyage_history";

export default {
  getVoyageHistory(voyageHistoryId) {
    return http.get(`${resource}/${voyageHistoryId}`);
  },

  deleteVoyageHistory(historyId) {
    return http.delete(`${resource}/${historyId}`);
  },

  getVoyageHistorySummary() {
    return http.get(`${resource}/summary`);
  },
};
